import PropTypes from 'prop-types';
import getRAG from '../../utils/ragStatus.js';

export default function SummaryStrip({
    items,
    overallPercent,
    reportingPeriod
}) {
    const isCurrentYear =
        reportingPeriod?.isCurrentYear === true ||
        reportingPeriod?.isCurrentQuarter === true;
    let green = 0;
    let yellow = 0;
    let red = 0;

    items.forEach((item) => {
        const { status } = getRAG(item, reportingPeriod);
        if (status === 'green') green++;
        else if (status === 'yellow') yellow++;
        else if (status === 'red') red++;
    });

    return (
        <div className="exec-pulse-overview" role="status" aria-live="polite">
            <div className="summary-strip">
                <div className="summary-box">
                    <span className="summary-label">KPIs</span>
                    <span className="summary-count">{items.length}</span>
                </div>
                <div className="summary-box">
                    <span
                        className="summary-dot summary-dot--green"
                        aria-hidden
                    />
                    <span className="summary-label">
                        {isCurrentYear ? 'On track' : 'Completed'}
                    </span>
                    <span className="summary-count">{green}</span>
                </div>
                <div className="summary-box">
                    <span
                        className="summary-dot summary-dot--yellow"
                        aria-hidden
                    />
                    <span className="summary-label">
                        {isCurrentYear ? 'At risk' : 'In progress'}
                    </span>
                    <span className="summary-count">{yellow}</span>
                </div>
                <div className="summary-box">
                    <span
                        className="summary-dot summary-dot--red"
                        aria-hidden
                    />
                    <span className="summary-label">
                        {isCurrentYear ? 'Off track' : 'Missed'}
                    </span>
                    <span className="summary-count">{red}</span>
                </div>
            </div>
            <div className="overview-completion">
                <span className="overview-completion__label">
                    Avg. completion
                </span>
                <span className="overview-completion__value">
                    {overallPercent}%
                </span>
            </div>
        </div>
    );
}

SummaryStrip.propTypes = {
    reportingPeriod: PropTypes.object,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            value: PropTypes.number,
            target: PropTypes.number,
            startDate: PropTypes.string,
            endDate: PropTypes.string
        })
    ).isRequired,
    overallPercent: PropTypes.number.isRequired
};
